import { Stack } from "types/generated";

export const isTrackedCommitOutdated = (stack: Stack): boolean =>
  !!stack.trackedCommit &&
  !!stack.trackedBranchHead &&
  stack.trackedCommit.hash !== stack.trackedBranchHead.hash;
